mutation SetMerchTestMode($merchOverlayId: ID!, $enabled: Boolean!, $scripted: Boolean, $confirmLive: String) {
  overlay: StreamToolsSetMerchTestMode(
    merchOverlayId: $merchOverlayId
    enabled: $enabled
    scripted: $scripted
    confirmLive: $confirmLive
  ) {
    merchOverlayId
    merchTestMode
    merchTestScript
    merchTestState
  }
}
